module.exports = __webpack_public_path__ + "img/symbol_10.489301cd.png";